// Bridge Lambda API client
import { apiOrigin } from '../utils/surface';

const BRIDGE_BASE = apiOrigin();

async function bridgeFetch(path: string, options: RequestInit = {}): Promise<any> {
  const res = await fetch(`${BRIDGE_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Bridge API error ${res.status}: ${text}`);
  }
  return res.json();
}

/** Send a command to a Bridge relay device */
export async function sendBridgeCommand(
  deviceId: string,
  action: string,
  channel: number | string,
  durationMs?: number
): Promise<any> {
  return bridgeFetch('/bridge/command', {
    method: 'POST',
    body: JSON.stringify({ device_id: deviceId, action, channel, duration_ms: durationMs }),
  });
}

/** Claim a Bridge device and associate it with a property */
export async function claimBridgeDevice(
  serialNumber: string,
  claimCode: string,
  propertyId: number | string,
  name: string
): Promise<any> {
  return bridgeFetch('/bridge/claim', {
    method: 'POST',
    body: JSON.stringify({ serial_number: serialNumber, claim_code: claimCode, property_id: propertyId, name }),
  });
}

/** List all claimed Bridge devices */
export async function getBridgeDevices(): Promise<any[]> {
  return bridgeFetch('/bridge/devices', { method: 'GET' });
}

/** Push a firmware update to a Bridge device */
export async function pushBridgeUpdate(deviceId: string, version: string): Promise<any> {
  return bridgeFetch('/bridge/update', {
    method: 'POST',
    body: JSON.stringify({ device_id: deviceId, version }),
  });
}
